import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';
import { warehouseValidationForm } from '../../utils/validationSchema';
import WarehosueForm from './WarehosueForm';
import Form from '../../layouts/Form';

const EditWarehouse = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    clearErrors
  } = useForm<any>({
    resolver: yupResolver(warehouseValidationForm),
    defaultValues: async () => {
      let data: any = await props?.refetch()
      return {
        ...data?.data,
        primary_contact: data?.data?.primary_contact ? data?.data?.primary_contact.slice(4) : null,
        secondary_contact: data?.data?.secondary_contact ? data?.data?.secondary_contact.slice(4) : null
      }
    }
  });

  const { handleEdit, isLoading } = props;
  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={isLoading}
    >
      <WarehosueForm
        errors={errors}
        clearErrors={clearErrors}
        register={register}
        setValue={setValue}
        getValues={getValues}
      />
    </Form>
  );

}

export default EditWarehouse
